import server from '@/h5/utils/http/index'
import config from '@/h5/config/index'
import axios from 'axios'

export const { baseURL, aliOssURL, apiURL, baseSecret } = config
export const activityInfo = (id) => {
  return server.request({
    url: `${baseURL}/xy/activity/info`,
    method: 'GET',
    data: { id }
  })
}

export const activityInfoByOSS = (id) => {
  const timestamp = new Date().getTime()
  return axios.get(`${aliOssURL}${id}.json?t=${timestamp}`)
}

/**
 * 动态请求
 * @returns
 */
export const customRequest = (baseUrl, url, requestType, headers, data) => {
  return server.request({
    url: baseUrl ? `${baseUrl}${url}` : `${apiURL}${url}`, // TODO: 兼容旧数据
    method: requestType,
    headers: headers,
    data
  })
}
